import { encode } from "html-entities";
import type Delta from "quill-delta";

export function deltaToText(doc?: Delta): string {
    if (!doc) return "";
    const result = doc.ops
        .map((o) => {
            if (o.attributes?.link) {
                return o.attributes.link;
            }
            return o.insert || "";
        })
        .join("")
        .trim();
    return result;
}

export function deltaToHtml(doc?: Delta): string {
    if (!doc) return "";
    const result = doc.ops
        .filter((o) => typeof o.insert === "string")
        .map((o) => {
            // Use HTML entities for non Ascii chars to circumvent bug in app version 1.0.8
            // TODO Remove this perhaps when app version 1.0.8 is no more in use?
            // @ts-expect-error
            const text = encode(o.insert, { mode: "nonAscii" });
            if (o.attributes?.link) {
                return `<a href="${o.attributes.link}" target="_blank">${text}</a>`;
            }
            return text;
        })
        .join("")
        .trim()
        .replaceAll("\n", "<br/>");
    const insideSpan = `<span>${result}</span>`;
    return insideSpan;
}
